import styled from 'styled-components';

import { COLORS } from '@theme/colors';

export const Container = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.01em;
`;

export const PageCopy = styled.div`
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  padding-right: 6px;
  padding-left: 6px;
`;

export const PageNumbers = styled.div`
  display: flex;
  flex-direction: row;
`;

export const PageNumber = styled.button<{ active: boolean }>`
  width: 27px;
  height: 27px;
  line-height: 27px;
  padding: 0;
  background-color: ${({ active }) => (active ? COLORS.WHITE : COLORS.WHITE40)};
  backdrop-filter: blur(24px);
  border-radius: 0;
  text-align: center;
  pointer-events: ${({ active }) => (active ? 'none' : 'auto')};

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background-color: ${COLORS.MERCURY};
  }
`;

export const Dots = styled.div`
  margin-right: 6px;
  width: 27px;
  height: 27px;
  line-height: 27px;
  display: inline-block;
  text-align: center;
`;
